import React from "react";
import "./Login.css";
import { Tooltip } from "@material-ui/core";
import Loader2 from "components/Loader/Loader2";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "redux/actions/login.action";
import { useNavigate } from "react-router-dom";
import Dashboard from "pages/Dashboard/Dashboard";

const Login = () => {
  const [loading, setLoading] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const nav = useNavigate();

  const userData = useSelector((state: any) => state.loginReducer);

  const dispatch: any = useDispatch();

  const userInfo = {
    email,
    password,
  };

  const loginHandler = async (e: any) => {
    e.preventDefault();
    await dispatch(loginUser(userInfo));
  };

  const token = JSON.parse(
    localStorage.getItem("userCredentials") || "{}"
  )?.accessToken;

  if (userData?.isLogged && token) {
    nav("/dashboard");
  }

  return (
    <>
      <div className="bg-[#9f9f9f] w-[100vw] h-[100vh]">
        <div className="vertical-center">
          <div className="h-[50px] w-[320px] mb-4 sm:w-[98vw] bg-white dark:text-white dark:bg-[#092c44] rounded-[5px] mx-auto mt-10 flex flex-col justify-center items-center ">
            <h1 className=" text-[25px] font-bold uppercase">Admin login</h1>
          </div>
          <div className="w-[320px] sm:w-[98vw] h-fit bg-slate-50 dark:bg-[#092c44] rounded-[10px] shadow-lg shadow-slate-500">
            <form
              className="block w-[100%]  mx-auto p-5   rounded-[5px]"
              onSubmit={loginHandler}
            >
              <input
                required
                type="email"
                placeholder="Email"
                className="w-[100%] my-4 block bg-[#cccccc] dark:bg-[#143b4f] rounded-[5px] mx-auto h-[40px] indent-2 cursor-text"
                onChange={(e: any) => setEmail(e.target.value)}
              />
              <input
                required
                type="password"
                placeholder="Password"
                className="w-[100%] mb-2  block bg-[#cccccc] dark:bg-[#143b4f] rounded-[5px] mx-auto h-[40px] indent-2 cursor-text"
                onChange={(e: any) => setPassword(e.target.value)}
              />
              <div>
                <button
                  type="submit"
                  className="w-[100%] my-4 block mx-auto text-white rounded-[5px] h-[42px] bg-[#0093df]  "
                >
                  {!userData?.loading ? <>Login</> : <Loader2 />}
                </button>
              </div>
            </form>{" "}
          </div>
          <Tooltip title="Unavailable option!" arrow>
            <div className="h-[50px] w-[320px]  sm:w-[98vw] bg-white dark:text-white dark:bg-[#092c44] rounded-[5px] mx-auto mt-7 flex flex-col justify-center hover:bg-slate-400 items-center ">
              <h1 className="hover:text-[#0093df]">New user</h1>
            </div>
          </Tooltip>
        </div>
      </div>
    </>
  );
};

export default Login;
